import { render, staticRenderFns } from "./SelectBoxV2.vue?vue&type=template&id=1c059dbe&scoped=true"
import script from "./SelectBoxV2.vue?vue&type=script&lang=ts"
export * from "./SelectBoxV2.vue?vue&type=script&lang=ts"
import style0 from "./SelectBoxV2.vue?vue&type=style&index=0&id=1c059dbe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c059dbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c059dbe')) {
      api.createRecord('1c059dbe', component.options)
    } else {
      api.reload('1c059dbe', component.options)
    }
    module.hot.accept("./SelectBoxV2.vue?vue&type=template&id=1c059dbe&scoped=true", function () {
      api.rerender('1c059dbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/SelectBoxV2.vue"
export default component.exports